export enum EntityType {
    Client = 'client',
    Contact = 'contact',
    Company = 'company',
    OrderType = 'orderType',
    WorkType = 'workType',
    Department = 'department',
    PayoutType = 'payoutType',
    Document = 'document',
    Performer = 'performer',
    User = 'user',
    Contract = 'contract',
    Scontract = 'scontract',
    Work = 'work',
    CrmEvent = 'crmEvent',
    FuelReport = 'fuelReport',
    Payout = 'payout',
    ScontractOrderType = 'scontractOrderType',
    Estimate = 'estimate',
    DocumentFile = 'documentFile',
    ComparisonAct = 'comparisonAct',
    WorkTime = 'workTime',
    WebUser = 'webUser',
    EstimatePositionType = 'estimatePositionType',
    Bank = 'bank',
    BaseLayer = 'baseLayer',
    PrintoutTemplate = 'printoutTemplate',
    WebTermsConditions = 'webTermsConditions',
    MotdMessage = 'motdMessage',
    Classifier = 'classifier',
    Invoice = 'invoice',
    Order = 'order',
    Sinvoice = 'sinvoice',
    ExpenseType = 'expenseType',
    Expense = 'expense',
    ExpenseRequestType = 'expenseRequestType',
    ExpenseRequest = 'expenseRequest',
    AbsenceType = 'absenceType',
    HelpMaterial = 'helpMaterial',
    Absence = 'absence',
    RouteType = 'routeType',
    Route = 'route',
    FuelReceipt = 'fuelReceipt',
    ProductReceipt = 'productReceipt',
    Car = 'car',
    Card = 'card',
    DocumentType = 'documentType',
    HrOrder = 'hrOrder',
}
